import User from '@/models/User.js';
import store from '@/store/Index.js';

export default (to, from, next) => {
    const user = User.find(store.state.Auth.user?.id);

    // If user is not authenticated, let other middleware handle it
    if (!user) {
        return next();
    }

    // If user must change password and is not going to password change route
    if (user.must_change_password && to.name !== 'password.change') {
        // Store the intended route for redirect after password change
        const redirectQuery = to.name !== 'login' ? { redirect: to.name } : {};
        return next({ name: 'password.change', query: redirectQuery });
    }

    // If user doesn't need to change password but is trying to access password change route
    if (!user.must_change_password && to.name === 'password.change') {
        return next({ name: 'home' });
    }

    // If user doesn't need to change password, continue normally
    return next();
};
